import React, { Component } from 'react';
import { Text, View, Pressable, StyleSheet } from 'react-native';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { OPComponent, I18n, Utils, NavBar } from '../components';

import { forgotPassword, resetState } from './actions';

import CommonStyles from './common_styles';
import StyledInput from './styled_input';
import { COLOR, __WEB__ } from '../../constants/styles';
import { PENDING, REQUESTING, SUCCESS, FAILED } from '../../actions/statusTypes';

import { ErrorView, AuthForm } from './auth_views';

class ForgotPassword extends OPComponent {
  static navigatorStyle = NavBar.authNavbarStyle;
  static statusBarStyle = NavBar.authStatusBarStyle;

  constructor(props) {
    super(props);

    this.state = {
      email: null,
      validationErrorMessage: null,
    };
  }

  componentWillUnmount() {
    this.props.actions.resetState();
  }
  componentDidMount() {
    this.props.actions.resetState();
  }

  errorMessage() {
    const submitError =
      this.props.authStatus === FAILED
        ? this.props.errorMessage?.message?.toString() || I18n.t('genericErrorMessage')
        : null;
    return this.state.validationErrorMessage || submitError;
  }

  handleEmailChange = (email) => this.setState({ email });

  submit = () => {
    if (!Utils.validate.email(this.state.email)) {
      this.setState({ validationErrorMessage: I18n.t('invalidEmail') });
      return;
    }
    if (this.state.validationErrorMessage) this.setState({ validationErrorMessage: null });

    this.props.actions.forgotPassword(this.state.email.trim());
  };

  render() {
    const props = this.props;
    return (
      <AuthForm
        {...props}
        errorMessage={this.errorMessage()}
        showActivityOverlay={props.authStatus === REQUESTING}
      >
        <View style={[styles.inputsContainer]}>
          <ErrorView {...props} errorMessage={this.errorMessage()} />

          <StyledInput
            autoFocus={false}
            label={I18n.ac('form.emailAddress')}
            value={this.state.email}
            autoCapitalize="none"
            keyboardType="email-address"
            returnKeyType="go"
            onChangeText={this.handleEmailChange}
            onSubmitEditing={this.submit}
          />

          <Pressable
            style={[
              styles.button,
              this.props.successMessage ? { backgroundColor: COLOR.textLight } : null,
            ]}
            disabled={this.props.authStatus === REQUESTING || !!this.props.successMessage}
            onPress={this.submit}
          >
            <Text style={styles.buttonText}>{I18n.t('form.submit')}</Text>
          </Pressable>
        </View>
      </AuthForm>
    );
  }
}

const styles = StyleSheet.create({
  ...CommonStyles,
});

function mapStateToProps(state, ownProps) {
  return {
    authStatus: state.screens.auth.status,
    errorMessage: state.screens.auth.errorMessage,
    successMessage: state.screens.auth.successMessage,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ forgotPassword, resetState }, dispatch),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);
